import React from 'react';

export const DBImpMain = ({ sheetNames, content, setSheet, sheetsWithDoubledFields, sheetsWithUnsetFields, activeSheet }) => {
  var headerSheetNames = sheetNames.map((sheet, index) => {
    return(
      <button className='regular-button' style={{ backgroundColor: activeSheet === sheet ? '#eee' : '#fff'}}
        onClick={() => setSheet(sheet)} key={index} className='sheet-name-button'>
        {sheet}
        <div className='bar' style={{ alignSelf: 'center', backgroundColor: sheetsWithDoubledFields.includes(sheet) ? '#f11' : sheetsWithUnsetFields.includes(sheet) ? '#ccc' : 'transparent'}} />
      </button>
    )
  });
  return(
    <div id='result-main' className='result-panel shadow' style={{ overflow: 'hidden'}}>
      <div className={'result-header left shadow overflow'}>
        {headerSheetNames}
      </div>
      <div className='result-content left overflow'>
        <ul>{content}</ul>
      </div>
    </div>
  )
};